module.exports = __webpack_public_path__ + "static/media/SD.8c2e9395.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/images/flags/svg/SD.svg
// module id = 679
// module chunks = 0